module.exports = __webpack_public_path__ + "img/base.ce4bd4db.png";